// extracted by mini-css-extract-plugin
export default {"novaTarefa":"Formulario_novaTarefa__2N-3b","inputContainer":"Formulario_inputContainer__vVD2o"};